import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import Alert from '@react/react-spectrum/Icon/Alert';
import Heading from '@react/react-spectrum/Heading';
import Wait from '@react/react-spectrum/Wait';

import { NON_IMS_EXTENSIONS } from '../../config/extensions';

import { RootContext } from '../../root/RootContext';

import { useSidebar } from '../App';

export default function OtherSolutions() {
  const history = useHistory();
  const { dispatch } = useContext(RootContext);
  const { show: showSidebar, hide: closeSidebar } = useSidebar();

  let data = {};
  let loading = false;
  let error = false;

  if (!NON_IMS_EXTENSIONS.length) {
    return null;
  }

  if (loading) {
    return (
      <div className="wait-wrapper">
        <Wait size="S" /> Loading other solutions...
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-wrapper">
        <Alert size="S" /> Couldn't load other solutions
      </div>
    );
  }

  const setActive = (sidebarComponent, actionPayload) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    dispatch({ type: 'aep/SET_ACTIVE', ...actionPayload });
    showSidebar(sidebarComponent);
  };

  return (
    <div key="non-ims-solutions">
      <Heading variant="pageTitle">Other</Heading>
      <small className="organization-id">Non-IMS Solutions</small>

      {NON_IMS_EXTENSIONS.map((ext, idx) => (
        <div key={'ext-' + idx}>
          {ext.renderItems(data, history, setActive, closeSidebar)}
        </div>
      ))}
    </div>
  );
}
